import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { mobileVersionSettingsAPI } from '../services/api';
import './Users.css';

const emptyForm = () => ({
  mobile_ios_minimum_version: '',
  mobile_android_minimum_version: '',
  mobile_force_update_title: '',
  mobile_force_update_message: '',
  mobile_ios_store_url: '',
  mobile_android_store_url: '',
});

const MobileVersionSettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(emptyForm);

  const load = async () => {
    setLoading(true);
    try {
      const res = await mobileVersionSettingsAPI.get();
      const d = res.data || {};
      setForm({
        mobile_ios_minimum_version: d.mobile_ios_minimum_version ?? '',
        mobile_android_minimum_version: d.mobile_android_minimum_version ?? '',
        mobile_force_update_title: d.mobile_force_update_title ?? '',
        mobile_force_update_message: d.mobile_force_update_message ?? '',
        mobile_ios_store_url: d.mobile_ios_store_url ?? '',
        mobile_android_store_url: d.mobile_android_store_url ?? '',
      });
    } catch (error) {
      toast.error(
        'Error loading mobile version settings: ' +
          (error.response?.data?.message || error.message),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await mobileVersionSettingsAPI.update(form);
      toast.success('Mobile version settings saved');
      await load();
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.response?.data?.errors ||
        error.message;
      toast.error('Save failed: ' + (typeof msg === 'object' ? JSON.stringify(msg) : msg));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading">Loading mobile version settings...</div>;

  return (
    <div className="users-container">
      <div className="table-container" style={{ padding: 20, maxWidth: 640 }}>
        <h3 style={{ marginBottom: 8 }}>Mobile app — force update</h3>
        <p style={{ color: '#6b5c63', marginBottom: 20, fontSize: 14, lineHeight: 1.5 }}>
          The installed app compares its{' '}
          <strong>native version</strong> (from <code>expo.version</code> at build time) to these
          minimums. If the app version is <strong>lower</strong>, users see a blocking screen until
          they update. Leave a minimum <strong>empty</strong> to disable forcing on that platform.
        </p>

        <form onSubmit={submit}>
          <div className="form-group">
            <label>Minimum iOS version</label>
            <input
              type="text"
              placeholder="e.g. 1.0.4 — blank = no forced update on iOS"
              value={form.mobile_ios_minimum_version}
              onChange={(e) =>
                setForm({ ...form, mobile_ios_minimum_version: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Minimum Android version</label>
            <input
              type="text"
              placeholder="e.g. 1.0.4 — blank = no forced update on Android"
              value={form.mobile_android_minimum_version}
              onChange={(e) =>
                setForm({ ...form, mobile_android_minimum_version: e.target.value })
              }
            />
          </div>
          <p style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
            Use <code>major.minor</code> or <code>major.minor.patch</code> (e.g. 1.2 or 1.2.0).
          </p>

          <div className="form-group">
            <label>Optional — force-update title</label>
            <input
              type="text"
              placeholder="Defaults to “Update required” if empty"
              value={form.mobile_force_update_title}
              onChange={(e) =>
                setForm({ ...form, mobile_force_update_title: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Optional — force-update message</label>
            <textarea
              rows={3}
              placeholder="Shown on the blocking screen"
              value={form.mobile_force_update_message}
              onChange={(e) =>
                setForm({ ...form, mobile_force_update_message: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label>iOS App Store URL (recommended)</label>
            <input
              type="url"
              placeholder="https://apps.apple.com/app/id…"
              value={form.mobile_ios_store_url}
              onChange={(e) =>
                setForm({ ...form, mobile_ios_store_url: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Google Play URL (recommended)</label>
            <input
              type="url"
              placeholder="https://play.google.com/store/apps/details?id=…"
              value={form.mobile_android_store_url}
              onChange={(e) =>
                setForm({ ...form, mobile_android_store_url: e.target.value })
              }
            />
          </div>

          <div className="form-actions">
            <button className="btn btn-primary" type="submit" disabled={saving}>
              {saving ? 'Saving…' : 'Save settings'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MobileVersionSettings;
